// Editorial service catalogue — shared between /booking, the homepage
// booking widget, and the floating StickySummary. Keep this as the
// canonical list of available "extras" the user can multi-select.

import { Sparkles, Compass, Car, UtensilsCrossed, Heart, Globe } from "lucide-react";

export const SERVICE_CATALOGUE = [
  {
    key: "spa",
    Icon: Sparkles,
    title: { en: "Spa & Wellness", fr: "Spa & Bien-être", es: "Spa y Bienestar" },
    desc: {
      en: "Hammam, argan rituals, bespoke couples' suites.",
      fr: "Hammam, rituels à l'argan, suites en duo.",
      es: "Hammam, rituales con argán, suites en pareja.",
    },
  },
  {
    key: "camel-ride",
    Icon: Compass,
    title: { en: "Camel caravan", fr: "Caravane de dromadaires", es: "Caravana de dromedarios" },
    desc: {
      en: "Sunset ride into the Erg Chebbi to your bivouac.",
      fr: "Coucher de soleil vers votre bivouac dans l'Erg Chebbi.",
      es: "Atardecer hacia su vivac en el Erg Chebbi.",
    },
  },
  {
    key: "quad",
    Icon: Compass,
    title: { en: "Quad & 4×4 dune", fr: "Quad & 4×4 dunes", es: "Quad y 4×4 dunas" },
    desc: {
      en: "Adrenaline crossings of the sea of sand.",
      fr: "Traversées adrénaline de la mer de sable.",
      es: "Travesías de adrenalina por la mar de arena.",
    },
  },
  {
    key: "trekking",
    Icon: Compass,
    title: { en: "Trekking & hikes", fr: "Trekkings & randonnées", es: "Trekking y senderismo" },
    desc: {
      en: "M'Goun valleys, Todra gorges, Berber paths.",
      fr: "Vallées du M'Goun, gorges du Todra, sentiers berbères.",
      es: "Valles del M'Goun, gargantas del Todra, senderos bereberes.",
    },
  },
  {
    key: "private-experience",
    Icon: Heart,
    title: { en: "Private experiences", fr: "Expériences privées", es: "Experiencias privadas" },
    desc: {
      en: "Cooking classes, Gnawa nights, private dinners under the stars.",
      fr: "Cours de cuisine, soirées Gnaoua, dîners privés sous les étoiles.",
      es: "Clases de cocina, noches Gnawa, cenas privadas bajo las estrellas.",
    },
  },
  {
    key: "gastronomy",
    Icon: UtensilsCrossed,
    title: { en: "Gastronomy", fr: "Gastronomie", es: "Gastronomía" },
    desc: {
      en: "Méchoui, tagines, tasting menus by our head chefs.",
      fr: "Méchoui, tajines, menus dégustation de nos chefs.",
      es: "Mechoui, tajines, menús degustación de nuestros chefs.",
    },
  },
  {
    key: "transfer",
    Icon: Car,
    title: { en: "Transfers & coordination", fr: "Transferts & coordination", es: "Traslados y coordinación" },
    desc: {
      en: "Airport pickups, 4×4 dune transfers, inter-hotel routes.",
      fr: "Aéroport, transferts 4×4, routes inter-hôtels.",
      es: "Aeropuerto, traslados 4×4, rutas entre hoteles.",
    },
  },
  {
    key: "itinerary",
    Icon: Globe,
    title: { en: "Curated itinerary", fr: "Itinéraire sur mesure", es: "Itinerario a medida" },
    desc: {
      en: "A complete multi-stay journey, written for your rhythm.",
      fr: "Un voyage multi-étapes complet, écrit à votre rythme.",
      es: "Un viaje multi-etapas escrito a su ritmo.",
    },
  },
];
